var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridOffIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 22,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48h-48z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8v2.91l4 4v-6.91h8v8h-6.91l4 4h2.91v2.91l4 4v-6.91h8v8h-6.91l4 4h2.91v2.91l4 4v-30.91c0-2.21-1.79-4-4-4h-30.91l4 4h2.91zm16 0h8v8h-8v-8zm-29.45-5.45l-2.55 2.54 4 4v30.91c0 2.21 1.79 4 4 4h30.91l4 4 2.54-2.55-42.9-42.9zm17.45 22.54l2.91 2.91h-2.91v-2.91zm-12-12l2.91 2.91h-2.91v-2.91zm8 26.91h-8v-8h8v8zm0-12h-8v-8h6.91l1.09 1.09v6.91zm12 12h-8v-8h6.91l1.09 1.09v6.91zm4 0v-2.91l2.91 2.91h-2.91z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridOffIcon);
export default __webpack_public_path__ + "static/media/Grid_Off_Icon.b40e8c9460ea3206ada791adc4a7be9d.svg";
export { ForwardRef as ReactComponent };